


import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class TabSelect extends Vue {
  @Prop() activeTabId!: string;

  private tabs: {
    id: string;
    title: string;
  }[] = [];

  private created() {
    const tabs =
      this.$slots.default?.map(slot => {
        const props = (slot.componentOptions?.propsData || []) as {
          tabId: string;
          tabTitle: string;
        };

        return {
          id: props.tabId,
          title: props.tabTitle
        };
      }) || [];

    this.tabs.push(...tabs);
  }

  @Emit()
  private switchTab(newTabId: string): string {
    return newTabId;
  }

  private get activeIndex(): number {
    return this.tabs.findIndex(tab => tab.id === this.activeTabId);
  }

  private get atTheEnd() {
    return this.activeIndex === this.tabs.length - 1;
  }
}
